import lazyLoadOnRender from '../../lazy/loadOnRender';

const UsagePolicyDialog = () =>
  import(/* webpackChunkName: "4-feat-usagepolicydialoglifecycle" */ './UsagePolicyDialogLifecycle');

export default lazyLoadOnRender({ loader: UsagePolicyDialog });
